import axios, {AxiosResponse} from "axios";


export type Measure = {
    id: string,
    measureNumber: number,
    title: string,
    description: string,
    type: MeasureType,
    group: MeasureGroup,
    unit?: string,
    requiresYearForOldImplementation: boolean,
    areaDescription?: string
}

export enum MeasureType {
    PERCENTAGE = "PERCENTAGE",
    AMOUNT = "AMOUNT",
    COMPLETE = "COMPLETE"
}

export enum MeasureGroup {
    ISOLATION_AND_FACADE = "ISOLATION_AND_FACADE",
    TECHNICAL_EQUIPMENT = "TECHNICAL_EQUIPMENT",
    ENERGY_PRODUCTION = "ENERGY_PRODUCTION"
}

export const EnergySupplies = ["Electricity", "RemoteHeating"] as const;

export type EnergySupply = typeof EnergySupplies[number];

export type GreenLoanResult = {
    achievedSavings: number,
    achievedEnergyMarking: string,
    achievedEnergySavingsKwh: number
}

export type GreenLoanInput = {
    projectInformation: ProjectInformation,
    includedMeasures: IncludedMeasure[],
}

export type ProjectInformation = {
    buildingType: BuildingType,
    buildYear: number,
    area: number,
    energySupply: EnergySupply
}

export enum BuildingType {
    ApartmentBlock = 'ApartmentBlock',
    House = 'House'
}

export type IncludedMeasure = {
    measureNumber: number,
    measureType: MeasureType,
    isOldImplementation: boolean
    implementationYear: number | null
    percentage?: number,
    amount?: number,
}

const baseUrl = process.env.REACT_APP_API_URL
const api = axios.create({
    baseURL: baseUrl
})

export class GreenLoanService {
    async getMeasures(): Promise<AxiosResponse<Measure[]>> {
        return api.get<Measure[]>("/measures")
    }

    async getMunicipalities(): Promise<AxiosResponse<string[]>> {
        return api.get<string[]>("/greenLoanModel/municipalities")
    }

    async calculateLoan(input: GreenLoanInput): Promise<AxiosResponse<GreenLoanResult>> {
        return api.put("/greenLoanModel/calculateLoan", input)
    }
}